<template>
  <div class="recharge-records">
    <div class="recharge-records-wrapper" v-show="recordsList.length">
      <van-list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <div class="item" v-for="(record, idx) in recordsList" :key="idx" @click="jumpDetails(record)">
          <div class="status minus" v-if="record.type === 'sub'">赠出</div>
          <div class="status add" v-else-if="record.type === 'add'">受赠</div>
          <div class="label">转赠名称：包钢福礼云购体验金</div>
          <div class="label">转赠额度：{{ record.rebate }}</div>
          <div class="label">转赠状态：{{ statsText[record.status] }}</div>
          <div class="label">转赠发起时间：{{ record.create_at }}</div>
          <div class="detail">
            <span>查看详情</span>
            <img class="icon" src="../images/icon-arrow-r.png" alt="">
          </div>
        </div>
      </van-list>
    </div>
    <no-records v-show="noRecords && !recordsList.length"></no-records>
  </div>
</template>

<script>
import mixin from '../mixin/index'
import NoRecords from './NoData'
import { List } from 'vant'
let flag = false
export default {
  name: 'rechargeRecords',
  mixins: [mixin],
  components: {
    NoRecords,
    VanList: List
  },
  data () {
    return {
      recordsList: [],
      noRecords: false,
      loading: false,
      finished: false,
      pageNum: 1
    }
  },
  computed: {},
  created () {
    this.$toast.loading({
      message: '正在加载...',
      duration: 300000
    })
    this.getRecords()
  },
  methods: {
    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getRecords(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 500)
    },
    jumpDetails (item) {
      let code, type
      if (item.type === 'sub') {
        code = item.association_order
        type = 1
      } else if (item.type === 'add') {
        code = item.serial_id
        type = 2
      }
      this.$router.push({ name: 'EGDetail', query: { code, type } })
    },
    async getRecords (pageNum) {
      this.loading = true
      const res = await this.$axios.get(`api/member/gift_experience/${pageNum || 1}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.recordsList = [...this.recordsList, ...data]
          this.loading = false
        } else if (code === 9006) {
          if (this.pageNum === 1) {
            this.noRecords = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.recharge-records-wrapper {
  padding: 0.30rem 0.24rem;
  // background-color: #fff;
  .item {
    background: #FFFFFF;
    padding: 0.24rem;
    margin-bottom: 0.20rem;
    border-radius: 0.10rem;
    font-size: 0.24rem;
    color: #565656;
    position: relative;
    .status {
      height: 0.40rem;
      padding: 0 0.16rem;
      border-radius: 999rem;
      font-size: 0.24rem;
      color: #FFFFFF;
      line-height: 0.40rem;
      position: absolute;
      top: 0.20rem;
      right: 0.16rem;
      &.minus {
        background: #FF9346;
      }
      &.add {
        background: #46A9FF;
      }
    }
    .label {
      line-height: 1.8em;
    }
    .detail {
      color: #6F8CFF;
      text-align: right;

      .icon {
        width: 0.08rem;
        height: 0.14rem;
        margin: 0.10rem 0 0 0.10rem;
      }
    }
  }
}
</style>
